import {Component, EventEmitter, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {FlowChartDataService} from '../../../services/flow-chart-data.service';
import {Guid} from 'guid-typescript';
import {take, takeUntil} from 'rxjs/operators';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {Subject} from 'rxjs';
import {FlowChartDesignerComponent} from '../../flow-chart/flow-chart-designer/flow-chart-designer.component';
import {PlatformCommandResponse, PlatformCommand} from '@shared/commands/command-base';
import {MenuConfig} from '@features/data-survey/models/flow-chart.model';
import { SnippetViewType } from '@features/data-survey/models/snippet-view-type';
import {DialogService} from '@shared/services/dialog-service';
import {CommandService} from '@core/services/command.service';
import {DialogModel} from '@shared/models/dialog.model';
import {SnackBarService} from "@core/services/snack-bar.service";

@Component({
    standalone: false,
    selector: 'particle-platform-tool-questionnaire',
  templateUrl: './platform-tool-questionnaire.component.html',
  styleUrls: ['./platform-tool-questionnaire.component.scss']
})
export class PlatformToolQuestionnaireComponent implements OnInit, OnDestroy {
  defaultExpansionPanelIndex = 0;
  ngUnsubscribe = new Subject<void>();
  @Input() flowchart: any;
  @Input() section: any;
  @Input() selectedTab: TabModel;
  @Input() flowChartId: string;
  @Input() sourceType: string;
  @Input() flowChartDataService: FlowChartDataService;
  @Input() actionEvents: EventEmitter<any> = new EventEmitter<any>();
  @Input() menuConfig: MenuConfig;

  showFieldKey: boolean;

  @ViewChild('flowChartDesigner', {static: true}) flowChartDesigner: FlowChartDesignerComponent;
  isReady = false;
  constructor(private fuseSplashScreenService: FuseSplashScreenService,
              private dialogService: DialogService,
              private commandService: CommandService,
              private snackBarService: SnackBarService) {
  }

   ngOnInit() {
     this.flowChartDataService.setFieldValues(this.selectedTab.tabData);
     if (this.selectedTab.tabData.ShowFieldKey === true) {
       this.showFieldKey = this.selectedTab.tabData.ShowFieldkey;
     }
     this.actionEvents.pipe(takeUntil(this.ngUnsubscribe))
       .subscribe(payload => {
         switch (payload?.type) {
           case 'edit-section':
             this.editSection();
             break;
           case 'delete-section':
             this.deleteSection();
             break;
           case 'add-field':
             this.addNewItem(false);
             break;
           case 'add-snippet':
             this.addSnippet();
             break;
           default:
             break;
         }
       });
   }



  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  addNewItem(isAddedAsField: boolean) {
    this.flowChartDesigner.onAdd(null, isAddedAsField);
  }
  addSnippet() {
    this.flowChartDesigner.addSnippet({}, true, 'Snippet', SnippetViewType.LiquidTemplate);
  }

  deleteSection() {
    console.log("Relative Path: " + this.selectedTab.tabData.RelativePath);
    const relativePath = this.selectedTab.tabData.RelativePath;
    if (this.selectedTab.tabData.FlowChartSectionId == this.section.id) {
      this.snackBarService.showError("You cannot delete the default field section!");
    } else {
      let moveSectionEnabled = true;
      if (this.flowChartDataService.getIsFieldSchema()) {
        moveSectionEnabled = false;
      }
      const dialogModel: DialogModel = DialogModel.create(
        'Delete Section',
        'DeleteSectionDialogComponent', {
          flowchartId: this.selectedTab.tabData['FlowChartId'],
          relativePath: relativePath,
          section: this.section,
          moveSectionEnabled: moveSectionEnabled
        },
        '765px',
        '765px'
      );
      this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(res => {
        if (res.action === 'OK') {
          this.flowChartDataService.deleteSectionCommandExecute(res, this.section, relativePath);
        }
      });
    }
  }

  editSection() {
    const dialogModel: DialogModel = DialogModel.create(
      'Edit Section',
      'PlatformToolEditSectionEditorComponent', {
        fieldName: 'Section Name', name: this.section.title,
        description: this.section.description
      },
      '765px',
      '765px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(res => {
      if (res.action === 'OK') {
        this.flowChartDataService.renameSectionCommandExecute(res, this.section);
        if (res.data && res.data.input) {
          const command = this.getActivityCommandForSectionEdit(res);
          this.sendActivityTrackCommandForRenameSection(command);
        }
      }
    });
  }
  sendActivityTrackCommandForRenameSection(command) {
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
      console.log(response);
    });
  }
  getActivityCommandForSectionEdit(currentSectionState) {
    const currentSectionName = currentSectionState.data.input.name;
    const previousSectionName = this.section.title;
    const currentDescription = currentSectionState.data.input.description;
    let previousDescription = this.section.description;
    if (previousDescription == null) {
      previousDescription = '';
    }
    const tabData = this.selectedTab.tabData;

    const activityCommand = new PlatformCommand('TrackActivityForQuestionnaireDesignCommand', 'FileStoreApi');
    activityCommand.fieldValues['DirectoryId'] = tabData['DirectoryId'];
    activityCommand.fieldValues['ChangeFieldType'] = [];

    if (previousSectionName !== currentSectionName) {
      activityCommand.fieldValues['PreviousName'] = previousSectionName;
      activityCommand.fieldValues['CurrentName'] = currentSectionName;
      activityCommand.fieldValues['ChangeFieldType'].push('SectionTitle');
    }

    if (previousDescription !== currentDescription) {
      activityCommand.fieldValues['SectionName'] = currentSectionName;
      activityCommand.fieldValues['ChangeFieldType'].push('SectionDescription');
    }

    return activityCommand;
  }
  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return true;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return true;
  }

  onLoad() {
  }
}
